export const measures = [
    [
        1,
        'Aggregate obligations'
    ],
    [
        2,
        'Ceiling'
    ],
    [
        3,
        'Current completion date'
    ],
    [
        4,
        'Ultimate completion date'
    ],
    [
        5,
        'Action obligations'
    ]
];
export function identityLabel(i) {
    return i ? `${i.piid} · ${i.agency} · ${i.subtier || 'Unknown subtier'} · ${i.referencedIdv || 'No parent identifier'} · ${i.kind.replace(/_/g, ' ')} · ${i.role} · ${i.partyKey || 'Unknown party'}` : 'Unresolved identity — needs context';
}
export function keyLabel(k) {
    return k ? `${measures.find(([m])=>m === k.measure)?.[1] || 'Unknown measure'} · ${k.scope} · ${k.period} · ${k.unit}` : 'Unknown scope';
}
export function valueLabel(f, unit = '') {
    if (!f || f.state === 0 || f.state === 2) return 'Unknown';
    if (f.state === 3) return 'Not applicable';
    if (f.state === 4) return 'Retrieval failed';
    return f.value.case ? `${f.value.value}${f.value.case === 'decimal' ? ` ${unit}` : ''}` : 'Unknown';
}
export function safeSourceUrl(location) {
    try {
        const url = new URL(location);
        return [
            'https:',
            'http:'
        ].includes(url.protocol) && !url.username && !url.password ? url.href : undefined;
    } catch  {
        return undefined;
    }
}
